<template>
  <el-container class="list" style="display:block;">
    <el-row :gutter="10" class="h-list lel">
			<el-col :span="2" :class="{'on-chose':isChose==0}" @click.native="onChose(0)">全部数据</el-col>
			<el-col :span="2" :class="{'on-chose':isChose==1}" @click.native="onChose(1)">在线数据</el-col>
			<el-col :span="2" :class="{'on-chose':isChose==2}" @click.native="onChose(2)">库中数据</el-col>
		</el-row>
		<el-row class="s-list lel">
			<el-col :span="8">
				<div class="block">
				<span class="demonstration">日期选择:</span>
				<el-date-picker
				  v-model="times"
				  type="daterange"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期"
				  format="yyyy 年 MM 月 dd 日"
				  value-format="yyyy-MM-dd">
				</el-date-picker>
			  </div>
			</el-col>
			<el-col :span="6">
				<span class="demonstration">员工选择:</span>
				 <el-select v-model="uId" placeholder="选择人员">
					<el-option
					  v-for="item in options"
					  :key="item.id"
					  :label="item.user_name"
					  :value="item.id">
					</el-option>
				 </el-select>
			</el-col>
			<el-col :span="7" class="l-search" style="margin-left: 45px;"><input type="text" v-model="name"/></el-col>
			<el-col :span="1" class="l-searched" @click.native="loadData()">搜索</el-col>
		</el-row>
		<el-container style="display:block;" class="c-list">
			<el-row class="c-list-title lel">
				<el-col :span="9">数据名称</el-col>
				<el-col :span="9">数据标签</el-col>
				<el-col :span="2">人员姓名</el-col>
				<el-col :span="2">操作</el-col>
				<el-col :span="2">发布时间</el-col>
			</el-row>
			<el-row class="c-list-content lel" v-for="(item,index) in list" :key="index">
				<el-col :span="9">

          <el-col :span="6">

          <el-upload
            class="avatar-uploader"

            :action="UploadUrl(item.id)"
            :show-file-list="false"
            @click.native="ceshi(index,item.id)"
            :on-success="handleAvatarSuccess">

            <img v-if="item.img_01" :src="item.img_01" class="img-content">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          </el-col>
          <el-col :span="5">
            <input type="checkbox" style="margin-top: 75px;" :checked='item.img_type' @change="qipao(item.id,item.img_type)" name="favorite" value="1" />原图

        </el-col>
					<el-col :span="11" class="bl">
						<el-row class="cl">【Hi兔】{{item.describe}}</el-row>

					</el-col>
				</el-col>
				<el-col :span="9" class="cl" @click.native="saveLable(item.id,item.describe,item.lable)">{{item.lable}}</el-col>
				<el-col :span="2" class="al">{{item.user_name}}</el-col>
				<el-col :span="2" class="bl">
					<el-row class="lel" @click.native="goToDetail(item.id)">编辑数据</el-row>
					<el-row class="lel" v-if="item.status == 1" @click.native="down(item.id,index)">下线</el-row>
					<el-row class="lel" v-if="item.status == 0" @click.native="up(item.id,index)">上线</el-row>
					<el-row class="lel" v-if="role == 'admin'" @click.native="open(item.id,index)">删除</el-row>
				</el-col>
				<el-col :span="2" class="al">{{item.add_time}}</el-col>
			</el-row>
		</el-container>
		<div class="page">
			<el-pagination
			  @size-change="loadData()"
			  @current-change="loadData()"
			  :current-page.sync="page"
			  :page-size="10"
			  background
			  layout="total,prev, pager, next, jumper"
			  :total="count">
			</el-pagination>
		</div>

  </el-container>
</template>

<script>

  export default {
    data() {
      return {

        list:['','',''],
		isChose:0,
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		role:window.localStorage.getItem('role'),
		count:0,
    imageId:0,
		page:1,
		name:'',
		times:'',
		uId:'',
    imgId:0,
		options: [],
		url:this.$store.getters.getUrl
      };
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
	  //var cip = returnCitySN["cip"];
// 	  if(this.$store.getters.getRole != 'admins'){
// 	  		   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 	  			   this.$router.push({ path: '/' })
// 	  		   }
// 	  }
      this.loadData();
	  this.loadUser();
    },
		methods:{
      UploadUrl(id){
        return "http://data3.yoooooo.com/index.php/index/data/pythonImgSaveGood"
        // return "http://y31p.yoooooo.com/index.php/index/data/itemImageChange?id="+id
      },
      handleAvatarSuccess(res, file) {

        this.imgChange(this.imgId,file.response.data)
        this.list[this.imageId]['img_01'] = URL.createObjectURL(file.raw);
      },
      ceshi(index,id){
        this.imageId = index
        this.imgId = id

      },
      imgChange(id,img){
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });
        axiosInstance({
        	method:'post',
        	params:{
            id:id,
            img:img

        	},
        	url:'http://y31p.yoooooo.com/index.php/index/data/itemImageChangeNew'
        })
        .then(res=>{


          this.list[this.imageId]['img'] = res.data.data




        })
        .catch(err=>{

        });
      },
      qipao(id,type){
        if(type == 0){
          type = 1
        }else{
          type = 0
        }
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });
        axiosInstance({
        	method:'get',
        	url:'http://y31p.yoooooo.com/index.php/index/data/qipao',
        	params:{
        		id:id,
            type:type,
        		token:this.token,
        		userId:this.userId
        	}
        })
        .then(res=>{
        	if(res.data.code == 200){
        		this.msg('修改成功!','success');
        		this.list[index].status = 1;
        	}else{
        		this.msg('请登录!','error');
        	}
        })
        .catch(err=>{

        });
      },
			saveLable(id,name,lable) {
				this.sLable = lable

				let html = '<div class="list-save">'+
						   '<div class="list-s-describe">'+name+'</div>'+
						   '<div class="list-s-name"><textarea id="sName" type="text" >'+name+'</textarea></div>'+
						   '<div class="list-s-lable"><textarea id="sLable" type="text" >'+lable+'</textarea></div>'+

						   '</div>';
				this.$alert(html, {
				  confirmButtonText:'确定',
				  dangerouslyUseHTMLString: true,

				}).then(() => {
					let newLable = document.getElementById('sLable').value
					let newName = document.getElementById('sName').value
					const axiosInstance = this.$axios.create({
						headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
						withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
					});
					axiosInstance({
						method:'post',
						url:'http://y31p.yoooooo.com/index.php/index/data/changeLable',
						params:{
							id:id,
							token:this.token,
							userId:this.userId,
							lable:newLable,
							name:newName
						}
					})
					.then(res=>{

						if(res.data.code == 200){
							this.$message({
								type: 'success',
								message: '修改成功'
							});
							this.loadData();
						}else{
							this.$message({
								type: 'error',
								message: '请登录'
							});
						}
					})
					.catch(err=>{

					});
				});
			},
			onChose(id){
				this.isChose = id;
				this.loadData();
			},
			loadData(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				let times = '';

				if(this.times != ''&&this.times != null){
					times = this.times[0]+','+this.times[1];
				}


				axiosInstance({
					method:'post',
					url:'http://y31p.yoooooo.com/index.php/index/data/loadData',
					params:{
						p:this.page,
						type:this.isChose,
						name:this.name,
						times:times,
						uId:this.uId
					}
				})
				.then(res=>{

					this.list = res.data.data;
					this.count = res.data.count;
				})
				.catch(err=>{

				});
			},
			loadUser(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});

				axiosInstance({
					method:'get',
					url:'http://y31p.yoooooo.com/index.php/index/data/getUserList',
					params:{

					}
				})
				.then(res=>{

					this.options = res.data.data;

				})
				.catch(err=>{

				});
			},
			down(id,index){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					url:'http://y31p.yoooooo.com/index.php/index/data/down',
					params:{
						id:id,
						token:this.token,
						userId:this.userId
					}
				})
				.then(res=>{
					if(res.data.code == 200){
						this.msg('修改成功!','success');
						this.list[index].status = 0;
					}else{
						this.msg('请登录!','error');
					}
				})
				.catch(err=>{

				});
			},
			up(id,index){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					url:'http://y31p.yoooooo.com/index.php/index/data/up',
					params:{
						id:id,
						token:this.token,
						userId:this.userId
					}
				})
				.then(res=>{
					if(res.data.code == 200){
						this.msg('修改成功!','success');
						this.list[index].status = 1;
					}else{
						this.msg('请登录!','error');
					}
				})
				.catch(err=>{

				});
			},
			msg(msg,type){
				this.$message({
				  message: msg,
				  type: type
				});
			},
			del(id,index){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					url:'http://y31p.yoooooo.com/index.php/index/data/del',
					params:{
						id:id,
						token:this.token,
						userId:this.userId
					}
				})
				.then(res=>{
					if(res.data.code == 200){
						this.msg('删除成功!','success');
						this.list.splice(index,1);
					}else{
						this.msg('请登录!','error');
					}
				})
				.catch(err=>{

				});
			},
			open(id,index) {
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					this.del(id,index);
				}).catch(() => {

				});
			},
			goToDetail(id) {
			  this.$router.push({
				name: 'Home',
				params: {
				  id: id
				}
			  })
			}

		}


  }
</script>

<style>
	.list-s-lable textarea{
		width: 350px;
		height: 100px;
		margin-left: 20px;
		margin-top: 20px;
	}
	.list-s-name textarea{
		width: 350px;
		height: 60px;
		margin-left: 20px;
		margin-top: 20px;
	}
	.list-s-describe{
		width: 350px;
		color: #3A8EE6;
		margin-left: 20px;
		margin-top: 20px;
	}
	.block{
		float: left;
	}
	.list{
		margin-left: 15%;
		margin-right: 15%;
	}
	.h-list{
		margin: 30px 30px 30px 20px;
		background: #fff;
		height: 50px;
	}
	.h-list .el-col{
		line-height: 50px;

	}
	.on-chose{
		background: #fff;
		border-bottom: 2px solid #FF9400;
		color: #FF9400;
		line-height: 48px;
	}
	.s-list{
		margin-bottom: 30px;
		margin-top: 30px;

	}
	.l-search{
		margin-left: 45px;
		text-align: right;
	}
	.l-search input{
		height: 30px;
		width: 320px;
	}
	.l-searched{
		background: orange;
		color: #fff;
		height: 35px;
		line-height: 35px;
		margin-left: 10px;
	}
	.s-d{
		background: #eeeeee;
		height: 30px;
		margin-left: 10px;
		line-height: 30px;
	}
	.c-list-title{
		border: 1px solid #a0a0a0;
		background: #eeeeee;
		height: 50px;
		line-height: 50px;
	}
	.c-list-title .el-col{
		text-align: center;
	}
	.c-list-content{
		height: 150px;
		border-bottom: 1px solid #939AA0;
	}
	.img-content{
		margin-top: 10px;
	}
	.lel{
		text-align: center;
	}
	.img-content{
		width: 120px;
		height: 120px;
	}
	.al{
		margin-top: 55px;
	}
	.cl{
		margin-top: 40px;
	}
	.bl{
		margin-top: 30px;
	}
	.bl .el-row{
		margin-bottom: 5px;
	}
	.bl .lel{
		color: blue;
	}
	.page{
		float: right;
		margin-top: 30px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/list.vue